var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Video"},[_c('video',{ref:"video",attrs:{"playsinline":"","src":_vm.videoPath,"autoplay":false},on:{"playing":_vm.onPlaying,"ended":_vm.onEnded}})])}
var staticRenderFns = []

export { render, staticRenderFns }